import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ManagerContractService } from "../../../../auth/service/manager-contract.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { locale as italian } from "../../../../i18n/it";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-edit-manager-contract",
  templateUrl: "./edit-manager-contract.component.html",
  styleUrls: ["./edit-manager-contract.component.scss"],
})
export class EditManagerContractComponent implements OnInit {
  public contentHeader: IContentHeader;

  public typeContract: any;

  public contract_manager: any;

  constructor(
    public route: ActivatedRoute,
    public _managerContractService: ManagerContractService,
    public _utilService: UtilsService,
    public _formBuilder: FormBuilder,
    public _routerService: Router,
  ) {
    this.typeContract = this.route.snapshot.paramMap.get("type");
  }

  async ngOnInit() {
    let title = this.typeContract.charAt(0).toUpperCase() + this.typeContract.slice(1);
    title = title.replace("_", " ");

    this.contract_manager = await this._managerContractService.getManagerContract(this.typeContract);

    this.contentHeader = {
      headerTitle: title,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGER_CONTRACT,
            isLink: true,
            link: "/dashboard/manager-contract",
          },
          {
            name: title,
            isLink: false,
          },
        ],
      },
    };
  }

  async save() {
    // aggiungere la funzione al (click)
    this._utilService.showLoading();
    await this._managerContractService
      .updateManagerContract(this.typeContract, { content: this.contract_manager })
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_CONTRACT_MANAGER" }).then(() => this._routerService.navigateByUrl("dashboard/manager-contract"));
      })
      .catch(async () => {
        await this._utilService.showSWALError({ text: "ERROR_UPDATE_CONTRACT_MANAGER" });
        await this._utilService.hideLoading();
      });
  }
}
